import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/equipment/liftingAntiCollisionPillar/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/equipment/liftingAntiCollisionPillar/detail',
    method: 'get',
    params: data,
  })
}
export async function createData(data) {
  return request({
    url: '/equipment/liftingAntiCollisionPillar/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/equipment/liftingAntiCollisionPillar/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/equipment/liftingAntiCollisionPillar/delete',
    method: 'post',
    data,
  })
}
